import { useEffect, useState } from "react";
import { Box, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { tabbedDataGridPage } from "../../../styles/commonPageStyles";
import ControlPlanes from "./ControlPlanes";
import { useNavigate, useParams } from "react-router-dom";

const TessellGcpControlPlanes = () => {
  const [selectedTab, setSelectedTab] = useState("dev");
  const navigate = useNavigate();
  const { deploymentStage } = useParams();

  useEffect(() => {
    setSelectedTab(deploymentStage);
  }, [deploymentStage]);

  const tabs = ["dev", "qa", "stage", "prod"];
  return (
    <Box sx={tabbedDataGridPage.mainBox}>
      <Box sx={tabbedDataGridPage.tabContainer}>
        <TabContext value={selectedTab}>
          <Box sx={tabbedDataGridPage.tabListBox}>
            <TabList
              onChange={(e, newValue) => {
                navigate(
                  `/apps/tessellgcp/deployments/${newValue}/control-planes`,
                  {
                    state: { dp: newValue },
                  }
                );
              }}
              textColor="secondary"
              indicatorColor="secondary"
              sx={tabbedDataGridPage.tabList}
            >
              {tabs.map((tab, i) => (
                <Tab
                  key={i}
                  label={tab}
                  value={tab}
                  icon={<></>}
                  iconPosition="end"
                ></Tab>
              ))}
            </TabList>
          </Box>
          {tabs.map((tab, i) => (
            <TabPanel key={i} value={tab}>
              <ControlPlanes />
            </TabPanel>
          ))}
        </TabContext>
      </Box>
    </Box>
  );
};

export default TessellGcpControlPlanes;
